<template>
  <div class="box-inner">
    <img :src="logo" alt />
    <p class="merchant_name">{{ merchant_name }}</p>
    <!-- <p class="merchant_name">福建省庆国香有限公司</p> -->

    <ProgressBar :value="value"></ProgressBar>
    <p class="title_box-inenr">恭喜您，识别成功</p>
    <p class="new_title-box-inner">区块链防伪认证中...</p>
    <iframe
      id="geoPage"
      width="0"
      height="0"
      frameborder="0"
      style="display: none"
      scrolling="no"
      src="https://apis.map.qq.com/tools/geolocation?key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"
    ></iframe>
  </div>
</template>
<script>
import axios from "axios";
// import { Toast } from "vant";
// import Maploader from "../unti/unti";
import ProgressBar from "../components/progressBar.vue";
export default {
  data() {
    return {
      latitude: "",
      longitude: "",
      errorPositionTxt: "",
      value: 0,
      defalutSlider: [
        {
          name: "商品信息",
          path: "/goodsInfo?defaultId=1",
          defaultId: 1,
        },
        {
          name: "防伪信息",
          path: "/securityInfo?defaultId=2",
          defaultId: 2,
        },
        {
          name: "企业信息",
          path: "/enterpriseInfo?defaultId=3",
          defaultId: 3,
        },
        {
          name: "质检信息",
          path: "/qsInfo?defaultId=4",
          defaultId: 4,
        },
        {
          name: "流通信息",
          path: "/circulationInfo?defaultId=5",
          defaultId: 5,
        },
        {
          name: "智能监测",
          path: "/intelligent?defaultId=7",
          defaultId: 7,
        },
      ],
      params: {
        batch_code: "",
        id: "",
        merchant_id: "",
        t: "",
      },
      params_: { address: "" },
      rectangle: "",
      logo: "",
      merchant_name: "",
      // latitude: "",
      // longitude: "",
    };
  },
  created() {
    this.Tmap();
    setTimeout(() => {
      this.getIp();
    }, 2000);
    try {
      this.$setApptitle("链白茶防伪溯源");
    } catch {
      console.log("not webview");
    }
  },
  mounted() {
    let params = this.$route.query;
    console.log(params);
    localStorage.setItem("merchant_id", params.merchant_id || "");

    if (params.key) {
      console.log(params.key);
      localStorage.setItem("falg", "1");
      localStorage.setItem("key", params.key || "");
      this.params_ = {
        chipData: params.key,
        address: this.r,
      };
      //  "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/api/user/uplinksyn",
      axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/ShopMerchantConfig",
          { key: params.key }
        )
        .then((res) => {
          if (res.data.message.code == 500) {
            setTimeout(() => {
              this.$router.push("/error");
            }, 100);
          } else {
            this.merchant_name = res.data.data.merchant_name;
            localStorage.setItem("merchant_name", this.merchant_name);
            this.logo = res.data.data.logo;
          }
        });
      axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetTraceWelcomePage",
          { key: params.key }
        )
        .then((res) => {
          localStorage.setItem("wel", JSON.stringify(res.data.data));
          console.log(res.data.data.scheme_url);
          if (res.data.data.scheme_url !== null) {
            return (location.href = res.data.data.scheme_url);
          }
          // this.getData();
        });
    } else {
      localStorage.setItem("falg", "2");
      axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/ShopMerchantConfig",
          { merchant_id: params.merchant_id }
        )
        .then((res) => {
          console.log(res);
          this.merchant_name = res.data.data.merchant_name;
          this.logo = res.data.data.logo;
        });
      axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetTraceWelcomePage",
          {
            markdetailId: params.id,
            merchant_id: params.merchant_id,
            t: params.t,
          }
        )
        .then((res) => {
          localStorage.setItem("wel", JSON.stringify(res.data.data));
          console.log(res.data.data.scheme_url);
          if (res.data.data.scheme_url !== null) {
            return (location.href = res.data.data.scheme_url);
          }
          this.getDataK(params);
        });
    }
    let timer = setInterval(() => {
      if (this.value >= 100) {
        this.value = 100;
        clearInterval(timer);
      } else {
        this.value += 0.1;
      }
    }, 6);
  },
  methods: {
    async Tmap() {
      window.addEventListener("message", function (event) {
        var loc = event.data;
        console.log(loc); // 显示你当前位置
        this.rectangle = loc.lng + "," + loc.lat;
        console.log(123123, this.rectangle);
        localStorage.setItem("rectangle", this.rectangle);
      });
    },
    async getBd() {
      const res = await this.$api.getBdIp();
      console.log(res);
    },
    async getIp() {
      const res = await this.$api.getGaodeApi(
        "3f138f9f1d809063d26884a2b6f52d5b"
      );
      if (res.data.status == 1) {
        // console.log(this.rectangle);
        this.rectangle = localStorage.getItem("rectangle");
        const r = await this.$api.getGaodeIp(
          this.rectangle,
          "3f138f9f1d809063d26884a2b6f52d5b"
        );
        console.log("r", r);
        this.params_.address =
          r.data.regeocode.addressComponent.province +
          r.data.regeocode.addressComponent.city +
          r.data.regeocode.addressComponent.district;
        this.getData();
      }
    },
    async getData() {
      if (this.params_.address) {
        await axios
          .post(
            // 正式
            // "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/api/user/uplinksyn",
            // "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/api/user/uplinksyn",
            "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetScanTraceList",
            // 正式
            // "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetScanTraceList",
            this.params_
          )
          .then((res) => {
            if (res.data.code === 200) {
              // 将数据根据id用Map格式存储
              console.log("rrrrr", res);
              let reData = JSON.parse(res.data.data);
              localStorage.setItem(
                "enterprise_merchant_id",
                reData.enterprise_merchant_id || ""
              );
              console.log(reData);
              localStorage.setItem("reData", JSON.stringify(reData));
              let dataObjcach = JSON.parse(res.data.data).data_list;
              let listsTg = JSON.parse(res.data.data).lists;
              let corporateLogoImageList = JSON.parse(
                res.data.data
              ).chain_enterprise_logo_list;
              localStorage.removeItem("lists");
              // 将推广信息按钮配置存储在本地
              if (listsTg) {
                localStorage.setItem("lists", JSON.stringify(listsTg));
              }
              localStorage.setItem(
                "corporateLogoImageList",
                JSON.stringify(corporateLogoImageList || [])
              );
              //遍历 将每个环节数据内容数据json字符串转为对象
              let mapData = new Object();
              console.log(dataObjcach, "dataObjcach2");

              // dataObjcach.forEach((element) => {
              //   mapData[element.trace_id] = element;
              //   if (element.msgItems) {
              //     console.log(element.msgItems);

              //     element.msgItems.forEach((value) => {
              //       value.op.op = JSON.parse(value.op.op);
              //     });
              //   }
              // });
              dataObjcach.forEach((element) => {
                mapData[element.trace_id] = element;

                if (element.msgItems && element.trace_name != "原料环节") {
                  element.msgItems.forEach((value) => {
                    value.op.op = JSON.parse(value.op.op);
                    console.log(value.op.op);
                  });
                }
              });
              localStorage.setItem("idInObj", JSON.stringify(mapData));
              localStorage.setItem("defalutObj", JSON.stringify(dataObjcach));
              // 存储获取请求的id数据
              localStorage.setItem("id", "26d326fb5ca54e08aca4acc5d0d2c085");
              localStorage.setItem("batch_Code", "");
              // localStorage.setItem("id", params.id);
              // localStorage.setItem("batch_Code", params.batch_code);
              //删除原料环节--原料环节不显示  只提供所需数据
              // let siderbarList = [];
              // let indexYL = dataObjcach.findIndex((v) => {
              //   return v.trace_id == "0";
              // });
              // if (indexYL != -1) {
              //   dataObjcach.splice(indexYL, 1);
              // }
              // //先进行排序
              // dataObjcach = dataObjcach.sort((a, b) => {
              //   return a.sort - b.sort;
              // });
              // let slider_ContentList = [];
              // dataObjcach.forEach((element) => {
              //   if (isNaN(Number(element.trace_id))) {
              //     siderbarList.push({
              //       name: element.trace_name,
              //       path: `/plantInfo`,
              //       defaultId: element.trace_id,
              //       sort: element.sort,
              //     });
              //     slider_ContentList.push(element);
              //   } else {
              //     //匹配默认环节
              //     let traceDefalut = this.defalutSlider.filter((v) => {
              //       return v.name == element.trace_name;
              //     });
              //     if (traceDefalut.length) {
              //       siderbarList.push({
              //         name: element.trace_name,
              //         path: traceDefalut[0].path,
              //         defaultId: traceDefalut[0].defaultId,
              //         sort: element.sort,
              //       });
              //       slider_ContentList.push(element);
              //     }
              //   }
              // });
              // window.localStorage.setItem(
              //   "slierBarListContent",
              //   JSON.stringify(slider_ContentList)
              // );
              setTimeout(() => {
                this.$router.push("/GoodsInfo");
              }, 100);
            }
          });
      }
    },
    async getDataK(params) {
      const { data: re } = await this.$api.getDataApi(
        params.id,
        params.batch_code,
        params.merchant_id,
        params.t,
        params.type
      );
      console.log(params);
      if (re.code === 200) {
        console.log(re);
        let reData = JSON.parse(re.data);
        console.log(reData);
        localStorage.setItem("reData", JSON.stringify(reData));
        // debugger;
        // if (!reData.data_list) {
        //     return Toast("暂无数据");
        // }
        let dataObjcach = JSON.parse(re.data).data_list;
        let listsTg = JSON.parse(re.data).lists;
        let corporateLogoImageList = JSON.parse(
          re.data
        ).chain_enterprise_logo_list;
        localStorage.removeItem("lists");
        // 将推广信息按钮配置存储在本地
        if (listsTg) {
          localStorage.setItem("lists", JSON.stringify(listsTg));
        }
        localStorage.setItem(
          "corporateLogoImageList",
          JSON.stringify(corporateLogoImageList || [])
        );
        //遍历 将每个环节数据内容数据json字符串转为对象
        let mapData = new Object();
        console.log(dataObjcach, "dataObjcach");

        dataObjcach.forEach((element) => {
          mapData[element.trace_id] = element;
          if (element.msgItems) {
            element.msgItems.forEach((value) => {
              value.op.op = JSON.parse(value.op.op);
            });
          }
        });
        localStorage.setItem("idInObj", JSON.stringify(mapData));
        localStorage.setItem("defalutObj", JSON.stringify(dataObjcach));
        // 存储获取请求的id数据
        localStorage.setItem("id", "26d326fb5ca54e08aca4acc5d0d2c085");
        localStorage.setItem("batch_Code", "");
        // localStorage.setItem("id", params.id);
        // localStorage.setItem("batch_Code", params.batch_code);
        //删除原料环节--原料环节不显示  只提供所需数据
        // let siderbarList = [];
        // let indexYL = dataObjcach.findIndex((v) => {
        //   return v.trace_id == "0";
        // });
        // if (indexYL != -1) {
        //   dataObjcach.splice(indexYL, 1);
        // }
        // //先进行排序
        // dataObjcach = dataObjcach.sort((a, b) => {
        //   return a.sort - b.sort;
        // });
        // let slider_ContentList = [];
        // dataObjcach.forEach((element) => {
        //   if (isNaN(Number(element.trace_id))) {
        //     siderbarList.push({
        //       name: element.trace_name,
        //       path: `/plantInfo`,
        //       defaultId: element.trace_id,
        //       sort: element.sort,
        //     });
        //     slider_ContentList.push(element);
        //   } else {
        //     //匹配默认环节
        //     let traceDefalut = this.defalutSlider.filter((v) => {
        //       return v.name == element.trace_name;
        //     });
        //     if (traceDefalut.length) {
        //       siderbarList.push({
        //         name: element.trace_name,
        //         path: traceDefalut[0].path,
        //         defaultId: traceDefalut[0].defaultId,
        //         sort: element.sort,
        //       });
        //       slider_ContentList.push(element);
        //     }
        //   }
        // });
        // window.localStorage.setItem(
        //   "slierBarListContent",
        //   JSON.stringify(slider_ContentList)
        // );
        setTimeout(() => {
          this.$router.push("/GoodsInfo");
          // 手动清除 Toast
          // Toast.clear();
        }, 100);
      }
    },
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.errorPosition
        );
      } else {
        this.errorPositionTxt = "不支持获取用户当前位置";
        console.log("不支持获取用户当前位置");
      }
    },
    showPosition(position) {
      console.log(position);
      console.log(position.coords);
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
    },
    errorPosition(error) {
      switch (error.code) {
        // 不允许获取当前位置
        case error.PERMISSION_DENIED:
          this.errorPositionTxt = "不允许获取当前位置";
          break;
        // 无法获取当前位置
        case error.POSITION_UNAVAILABLE:
          this.errorPositionTxt = "无法获取当前位置";
          break;
        // 获取位置的请求超时。
        case error.TIMEOUT:
          this.errorPositionTxt = "获取位置请求超时。";
          break;
        // 获取位置操作超时
        case error.UNKNOWN_ERROR:
          this.errorPositionTxt = "获取位置操作超时";
          break;
      }
    },
  },
  components: { ProgressBar },
};
</script>
<style scoped lang="scss">
P {
  margin-block-start: 0em;
  margin-block-end: 0em;
}

.box-inner {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-top: 245px;
    width: 374px;

    // margin-bottom: 200px;
  }

  .title_box-inenr {
    margin-top: 32px;
    margin-bottom: 16px;
    font-size: 40px;
    font-weight: bold;
    color: #000000;
  }

  .new_title-box-inner {
    font-size: 28px;
    color: #808080;
  }
  .merchant_name {
    margin-top: 20px;
    margin-bottom: 150px;
    font-size: 36px;
  }
}
</style>